export default "__VITE_ASSET__69779ce4__"